import React, { useRef, useState } from 'react';
import { SymbolType, CdnObjectType } from '@/types';
import { AudioPlayer, CdnMedia, RoundPlayButton } from '@/components';
import { useAssetCdn } from '@/context/Ui';

interface ManageAdminSymbolsWordProps {
  word: string;
  includeImage?: boolean;
}

export const ManageAdminSymbolsWord = ({
  word,
  includeImage = true,
}: ManageAdminSymbolsWordProps) => {
  const playerRef = useRef<AudioPlayer>(null);

  const mediaUrl = useAssetCdn(word, SymbolType.Word, CdnObjectType.Audio);

  const [playerReady, setPlayerReady] = useState(false);

  return (
    <>
      <h6 className="font-bold">Word: {word}</h6>

      {includeImage && (
        <CdnMedia
          className="w-full h-auto"
          symbol={word}
          symbolType={SymbolType.Word}
          objectType={CdnObjectType.Image}
          width={280}
          height={280}
        />
      )}

      {mediaUrl ? (
        <>
          <AudioPlayer
            ref={playerRef}
            src={mediaUrl}
            onReadySrc={() => setPlayerReady(true)}
          />

          <RoundPlayButton
            onClick={() => {
              playerRef.current?.play();
            }}
            size="sm"
            disabled={!playerReady}
          />
        </>
      ) : (
        <p>Word not found</p>
      )}
    </>
  );
};
